import totalAgentTypes from './totalAgentTypes';

export default function agentFinder(value) {
  return totalAgentTypes.find(item => item.value === value);
}
